module.exports = __webpack_public_path__ + "static/backend-team.292e7b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/backend-team.png
// module id = 664
// module chunks = 227585929013685